// Auth and user profile
export const LOGIN = 'backoffice/auth/login'
export const VERIFY_OTP = 'backoffice/auth/verify-otp'
export const RESEND_OTP = 'backoffice/auth/resend-otp'
export const VERIFY_2FA = 'backoffice/auth/verify-2fa'
export const REQUEST_2FA = 'backoffice/auth/request-2fa'
export const USER_PROFILE = 'api/v1/user/user_profile.php'

// Campaign
export const GET_CAMPAIGN_LIST = 'backoffice/campaigns'
export const GET_CAMPAIGN_CONTENT = 'backoffice/campaign/content'
export const CREATE_CAMPAIGN = 'backoffice/campaigns'
export const GET_CAMPAIGN_PRE_REGISTER = 'backoffice/pre-register'
export const UPDATE_CAMPAIGN_CONTENT =
  'backoffice/campaigns/save-content'
export const GET_CAMPAIGN_DETAIL = '/backoffice/campaigns'
export const CREATE_CAMPAIGN_PRODUCT =
  '/backoffice/campaigns/add-products'
export const EXPORT_PRODUCT = `/backoffice/product/type-export`

// Branch
export const GET_BRANCH_LIST = 'backoffice/branch/index'
export const GET_BRANCH_DETAIL = 'backoffice/branch/show'
export const CREATE_BRANCH = 'backoffice/branch/store'
export const UPDATE_BRANCH = 'backoffice/branch/update'
export const DELETE_BRANCH = 'backoffice/branch'
export const UPDATE_BRANCH_TIME = 'backoffice/branch/add-times'
export const BRANCH_UPLOAD_EXCEL = 'backoffice/branch/upload'
export const UPDATE_BRANCH_TIME_ONLY = 'backoffice/branch/update-time'
export const EXPORT_BRANCH = 'backoffice/branch/export'
// Product
export const GET_PRODUCT_ALL = '/backoffice/product/type'
export const GET_PRODUCT_BUNDLE = '/backoffice/product/type/bundle'
export const GET_PRODUCT_ADDITIONAL =
  '/backoffice/product/type/additional'
export const CREATE_UPDATE_PRODUCT = 'backoffice/product/type/store'
export const UPDATE_PRODUCT_SET_STOCK = 'backoffice/product/set-stock'
export const PRODUCT_UPLOAD_EXCEL = 'backoffice/product/upload'
export const EXPORT_MAIN_PRODUCT = 'backoffice/main-products-export'

// main product
export const GET_MAIN_PRODUCT_LIST = '/backoffice/main-products'
export const CREATE_MAIN_PRODUCT_LIST = '/backoffice/main-products'
export const UPDATE_MAIN_PRODUCT_LIST = '/backoffice/main-products'
export const MAIN_PRODUCT_UPLOAD_EXCEL =
  'backoffice/main-products/upload'
export const UPDATE_MAIN_PRODUCT_QTY = '/backoffice/main-products-qty'
export const DELETE_PRODUCT = 'backoffice/product/type'

// Coupon
export const GET_COUPON_LIST = 'backoffice/coupons'
export const CREATE_UPDATE_COUPON = 'backoffice/coupons'
export const COUPON_UPLOAD_EXCEL = '/backoffice/coupons/upload'
export const COUPON_DELETE = '/backoffice/coupons'
export const GET_COUPON_SHOW = 'backoffice/coupons'
export const EXPORT_COUPON = 'backoffice/coupons-export'

// Coupon Purchased
export const COUPON_PURCHASED = 'backoffice/next-coupons'

// Utils
export const POST_UPLOAD_MEDIA = 'backoffice/utility/media/store'

// Order
export const GET_ORDER_LIST = 'backoffice/orders'
export const GET_ORDER_LIST_V2 = '/backoffice/orders-v2'

// payment
export const GET_PAYMENT_LIST = 'backoffice/payment-types'

// logs
export const GET_ITEC_LOGS = 'backoffice/itec-logs'
export const GET_GATEWAY_LOGS = 'backoffice/payment-logs'

export const STATIC_PAGE = 'backoffice/static-page'

// product qouta

export const PRODUCT_QUOTA_TIME = '/backoffice/product-quota-time'
export const PRODUCT_QUOTA_UPLOAD =
  '/backoffice/product-quota-time-upload'

export const REPORT_PRODUCT_QUOTA_TIME = '/backoffice/report/orders'
export const EXPORT_REPORT_PRODUCT_QUOTA_TIME =
  '/backoffice/report/quota'
export const REPORT_LOT_OF_PRODUCT_QUOTA =
  '/backoffice/report/quota-lot-export'

export const GET_SMS = '/backoffice/order-delivery-message'
export const SEND_SMS =
  '/backoffice/order-delivery-message/send-message'
export const UPLOAD_SMS = '/backoffice/order-delivery-message/upload'
